import { Component, HostListener, OnInit } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { UserService } from './services/user.service';
import { SocketService } from './services/socket.service';
import { environment } from 'src/environments/environments';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  messageReceived = false;
  messageData: any = {};
  // loadAPI: Promise<any>;

  constructor(
    private afMessaging: AngularFireMessaging,
    private api: UserService,
    private socketService: SocketService
  ) {
    // this.loadAPI = new Promise((resolve) => {
    //   this.loadScript();
    //   resolve(true);
    // });
  }

  ngOnInit() {
    this.initFirebaseMessaging();
    this.requestPermission();
    this.initSocket();
  }

  initSocket() {
    const token = localStorage.getItem(`${environment.appName}` + 'user');
    if (token) {
      this.socketService.connect(token);
    }
  }


  initFirebaseMessaging() {
    this.afMessaging.messages.subscribe((payload: any) => {
      console.log("📩 Firebase Message:", payload);

      const userType = localStorage.getItem("type");
      let icon = "assets/images/logo.png";
      if (userType === "laundry") icon = "assets/images/laundry-icon.png";
      else if (userType === "apartment") icon = "assets/images/apartment-icon.png";
      else if (userType === "restaurant") icon = "assets/images/restaurant-icon.png";

      const notification = new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: icon,
      });

      // Add small delay to ensure browser lets us play audio
      setTimeout(() => {
        // this.playCustomSound();
      }, 500);

      notification.onclick = () => {
        if (userType === "apartment") {
          window.location.href = "/room-new-order";
        } else if (userType === "laundry") {
          window.location.href = "/dashboard-laundry";
        } else if (userType === "restaurant") {
          window.location.href = "/restaurant-dashboard";
        } else {
          window.location.href = "/dashboard";
        }
        notification.close();
      };

      this.messageReceived = true;
      this.messageData = payload.notification;
    });
  }


  requestPermission() {
    if ("Notification" in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          this.afMessaging.requestToken.subscribe({
            next: (token:any) => {
              localStorage.setItem("FCM_Token", token);
              console.log("✅ FCM Token:", token);
            },
            error: (err) => {
              console.error("❌ FCM Token Error:", err);
            },
          });
        } else {
          console.warn("❌ Notification permission denied");
          localStorage.removeItem("FCM_Token");
        }
      });
    }
  }

 

  playCustomSound() {
    console.log("🔊 Attempting to play sound...");

    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    const audioContext = new AudioContext();

    // Ensure context is resumed
    if (audioContext.state === 'suspended') {
      audioContext.resume().then(() => {
        console.log("🎵 Audio context resumed");
      });
    }

    const soundUrl = "/assets/images/swiggy_new_order.mp3"; // Use absolute path for reliability

    fetch(soundUrl)
      .then(res => res.arrayBuffer())
      .then(buffer => audioContext.decodeAudioData(buffer))
      .then(decoded => {
        const source = audioContext.createBufferSource();
        source.buffer = decoded;
        source.connect(audioContext.destination);
        source.start();
        console.log("✅ Sound played!");
      })
      .catch(err => console.error("🔇 Sound error:", err));
  }


  // loadScript() {
  //   const scripts = [
  //     "assets/js/jquery.min.js",
  //     "assets/js/bootstrap.min.js",
  //     "assets/js/slick.min.js",
  //   ];

  //   scripts.forEach((src) => {
  //     const script = document.createElement("script");
  //     script.src = src;
  //     script.type = "text/javascript";
  //     script.async = false;
  //     document.body.appendChild(script);
  //   });
  // }
}
